import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import Image from "../../assets/background.png";
import ImageBack from "../../assets/back.png";
import Header from "../../components/header/header";
import "./reservationGuideline.css";

import { authentication } from "../../utils/config";

const ReseravtionGuideline = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);
  useEffect(() => {
    // check line account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
    };
    auth();
  }, []);

  return (
    <Container
      fluid
      className="vh-100 d-flex flex-column  align-items-center backgroundStyle"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="w-100 mt-2">
      <Header title="線上預約說明">
        <img
          src={ImageBack}
          alt="Back"
          style={{ width: "20px", objectFit: "contain" }}
        />
      </Header>
      </div>
      <hr className="reservGuildeline-hr-up"></hr>

      <ol className="reservGuildeline-list mx-auto">
        <li className="reservGuildeline-li">
          恕<span className="reservGuildeline-red">不接受當日預約</span>
          ，若需機器維修請直接電話聯繫客服
        </li>

        <li className="reservGuildeline-li">
          預約完成後收到客服人員傳簡訊通知才算預約成功!<br></br>
          <span className="reservGuildeline-red">
            ※請確保開啟元大官方帳號提醒功能
          </span>
        </li>

        <li className="reservGuildeline-li">已過保之機器將<span className="reservGuildeline-red">酌收保養費用</span></li>
        <li className="reservGuildeline-li">
        <span className="reservGuildeline-red">目前僅接受保養預約</span>，欲維修請LINE或電話聯繫元大客服(04)2350-5000
        </li>
      </ol>

      <hr className="reservGuildeline-hr-down"></hr>
      <Button
        className="btn-custom-green reservGuildeline-button"
        onClick={() => {
          navigate("/reservation", { replace: true });
        }}
      >
        同意並下一步
      </Button>
    </Container>
  );
};

export default ReseravtionGuideline;
